import { ContainerModule } from 'inversify';
import { StateSerializationPluginSymbol } from '@/app/state-serialization/api';
import { ExamSessionStateProtobufSerializer } from './exam-session-state-protobuf-serializer'

export const examSessionTrackingSerializationModule = new ContainerModule((bind) => {
  bind(StateSerializationPluginSymbol).to(ExamSessionStateProtobufSerializer)
});
